import { useContext, useCallback } from 'react'

import { AppContext } from '@/components/context/AppContext'
import { getButtonDataAttributes } from '@/utils/miscellaneous'

const useDataLayer = () => {
  const { googleDataLayer, dataAction } = useContext(AppContext)

  const logEvent = useCallback((event: string, name: string): void => {
    if (typeof googleDataLayer === 'undefined') {
      console.warn('The "googleDataLayer" option does not have a valid Gtag DataLayer object.')
      return
    }

    const { dataCategory, dataLabel } = getButtonDataAttributes(name, dataAction)

    googleDataLayer.push({
      event,
      eventCategory: dataCategory,
      eventAction: dataAction,
      eventLabel: dataLabel
    })
  }, [googleDataLayer, dataAction])

  return {
    logEvent
  }
}

export default useDataLayer
